import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FieldTextarea from '../../common/Fields/FieldTextarea';
import { useDispatch, useSelector } from 'react-redux';
import { testSelectors } from '../../store/selectors/test';
import Button from '../../common/Buttons/Button';
import SpeakButton from '../../common/SpeakButton/SpeakButton';
import ErrorField from '../../common/Errors/ErrorField';
import actions from '../../store/actions';
import { checkTestThunk, continueTestThunk } from '../../store/thunks/test';
import { authSelectors } from '../../store/selectors/auth';
import './hint-test.scss';
import { leaveTestStage } from '../../utils/testStage';

const TestTranslate = ({setOpenModal}) => {
  const dispatch = useDispatch();

  const auth = useSelector(authSelectors);
  const token = auth.token;
  const test = useSelector(testSelectors);
  const testInfo = test.test;
  const loadBtn = test.loadBtn;
  const error = test.error;
  const check = test.check;

  const [answerVal, setAnswerVal] = useState('');
  const [isAnswered, setIsAnswered] = useState(false);
  const isEmptyAnswer = answerVal.trim() === '';

  useEffect(() => {
    setIsAnswered(false);
    setAnswerVal('');
    dispatch(actions.test.checkTest({}));
    dispatch(actions.test.getTestError(''));
  }, [testInfo]);

  const handleCheckAnswer = (blockId, taskId, token) => {
    if ((isAnswered && !error) || isEmptyAnswer) return;

    const data = {blockId, taskId, data: {answer_text: answerVal}, token};
    dispatch(actions.test.getTestError(null));
    dispatch(actions.test.checkTest({}));
    dispatch(actions.test.getTestError(''));
    dispatch(checkTestThunk(data));
    setIsAnswered(true);
  };

  const setNextTest = (id, token) => {
    const data = {id, token};
    leaveTestStage();
    setIsAnswered(false);
    setAnswerVal('');
    dispatch(actions.test.checkTest({}));
    dispatch(actions.test.getTestError(''));
    localStorage.setItem('currentTestId', JSON.stringify(id));
    dispatch(continueTestThunk(data));
  };

  const setTestModal = () => {
    setOpenModal(true);
  };

  return (
    <>
      <div className="test__field">
        <FieldTextarea        
          id='answer' 
          name="answer" 
          value={answerVal} 
          placeholder='Введіть вашу відповідь' 
          onChange={(e) => setAnswerVal(e.target.value)} 
          disabled={Object.keys(check)?.length ? true : false}
          formClass={check?.is_correct === false ? 'incorrect shake' : check?.is_correct === true ? 'correct blink' : ''}  
        />
        {error &&  <ErrorField errorText={error} />}

        {Object.keys(check)?.length > 0 && check?.is_correct 
          ? <span className="success-field">{check.correct_text}</span>
          :  <ErrorField errorText={check.correct_text} />}

        {check?.is_correct === false && check?.answer_diff ?
        <div className="test__hint answer-diff">
          <div className="answer-diff__row">
            <span className="answer-diff__label">Ваша відповідь:</span>
            <span className="answer-diff__text">
              {check.answer_diff.user.map((segment, idx) => (
                <span key={idx} className={segment.state === 'ok' ? '' : 'answer-diff__wrong'}>{segment.text}</span>
              ))}
            </span>
          </div>
          <div className="answer-diff__row">
            <span className="answer-diff__label">Має бути:</span>
            <span className="answer-diff__text">
              {check.answer_diff.correct.map((segment, idx) => (
                <span key={idx} className={segment.state === 'ok' ? '' : 'answer-diff__missing'}>{segment.text}</span>
              ))}
            </span>
            <SpeakButton
              text={check.answer_diff.correct.map((segment) => segment.text).join('')}
              lang={testInfo.tts_lang}
            />
          </div>
          <div className="answer-diff__note">Розділові знаки та великі літери не впливають на результат.</div>
        </div> : ''}

        {Object.keys(check)?.length > 0 && check?.correct_options?.length > 0 ? 
        <div className="test__hint hint-test">
          <div className="hint-test__title">{check.correct_options_text}</div>
          {check?.correct_options.length > 0 && check?.correct_options.map((item, idx) => (
            <div key={idx} className="hint-test__item">
              {idx + 1}. {item}
              <SpeakButton text={item} lang={testInfo.tts_lang} className="hint-test__speak" />
            </div>
          ))}
        </div> : ''}
      </div> 
      <div className="test__btns">
        {isAnswered && !error
        ? <Button buttonBg='green' textSize='md' btnRadius='md' disabled={loadBtn ? true : false}
            onClick={() => setNextTest(testInfo.el_homework_block_id, token)}
          >
            Далі
          </Button>
        : <Button buttonBg='green' textSize='md' btnRadius='md' disabled={loadBtn || isEmptyAnswer}
            onClick={() => handleCheckAnswer(testInfo.el_homework_block_id, testInfo.homework_task_id, token)}
          >
            Перевірити
          </Button>}
        <Button buttonBg='light' iconSvg='flag' iconColor='violet' onClick={() => setTestModal()}>
          Повідомити про помилку
        </Button>
      </div>
    </>
  );
};

TestTranslate.propTypes = {
  setOpenModal: PropTypes.func,
};


export default TestTranslate;